export default "__VITE_ASSET__DRdHlUWu__"